"use client";

import { useDateTimeFormatter } from "@opensea/i18n";
import { motion } from "motion/react";
import { useEffect, useMemo, useRef } from "react";
import { Chip } from "../../Chip";

// -- Types ----------------------------------------------------------------------------------------

// -- Component ------------------------------------------------------------------------------------
export function CandlestickChartTooltip({
  crosshair,
  onPriceHover
}) {
  const tooltipRef = useRef(null);
  const dateTimeFormatter = useDateTimeFormatter();
  const point = crosshair?.point;
  const seriesArr = Array.from(crosshair?.seriesData?.values() || []);
  const olhc = seriesArr[0];
  const volume = seriesArr[1];
  const tooltipWidth = tooltipRef.current?.offsetWidth;
  const candle = useMemo(() => {
    if (!(olhc && volume)) {
      return undefined;
    }
    return {
      time: olhc.time.toString(),
      open: olhc.open.toString(),
      high: olhc.high.toString(),
      low: olhc.low.toString(),
      close: olhc.close.toString(),
      volume: volume.value.toString()
    };
  }, [olhc?.time, olhc?.open, olhc?.high, olhc?.low, olhc?.close, volume?.value]);
  useEffect(() => {
    if (onPriceHover && candle) {
      onPriceHover(candle);
    } else if (onPriceHover && !candle) {
      onPriceHover(undefined);
    }
  }, [onPriceHover, candle]);
  if (!candle) {
    return null;
  }
  function calculateLeft() {
    if (!(point && tooltipWidth)) {
      return 0;
    }

    // Center the tooltip above the x-axis position
    const centeredPosition = point.x - tooltipWidth / 2;

    // Get chart container bounds for proper boundary calculation
    const chartContainer = tooltipRef.current?.parentElement?.querySelector(
    // CSS selector for class name of tv-lightweight-charts
    ".tv-lightweight-charts");
    const containerWidth = chartContainer?.clientWidth || window.innerWidth;

    // Ensure tooltip doesn't go off-screen relative to the chart container
    return Math.max(0, Math.min(centeredPosition, containerWidth - tooltipWidth));
  }
  const translate = {
    x: calculateLeft(),
    y: 0
  };
  const time = new Date(Number(candle.time) * 1000);
  return <motion.div animate={{
    opacity: 1
  }} className="pointer-events-none absolute top-0 z-4" initial={{
    opacity: 0
  }} ref={tooltipRef} style={{
    transform: `translate3d(${translate.x}px, ${translate.y}px, 0px)`
  }}>
      <Chip>
        {dateTimeFormatter(time, {
        display: "datetime",
        weekday: "short",
        year: "numeric"
      })}
      </Chip>
    </motion.div>;
}